/**
 * file_name.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Util from 'canvas/base/dev/util/B_Util';
import B_Define from 'canvas/base/dev/util/B_Define';

// [#] 다중상속 클래스에서는 클래스 함수를 실행시키지 마세요!
const B_GridChild = (function (superclass) {

	// [V]
	const $ = {
		_gridX: null,
		_gridY: null,
		_gridDisX: null,
		_gridDisY: null,
		_size: null,
	};

	class B_GridChild extends superclass {

		constructor(obj) {
			super(obj);

			try {
				// [E] obj.parent
				if (typeof obj.parent != 'undefined') this._strParent = obj.parent;

				// [S] parent grid length
				this._gridDisX = this._objParent._lenX;
				this._gridDisY = this._objParent._lenY;

				// [E] res 참조객체 (size)
				if (obj.res) obj.size = this._checkRes(obj.size, this.CODMOS._res[obj.res].size, 100);
				else obj.size = 100;
				this._size = obj.size;

				// [S] 물리속성 처리 (x, y, w, h, pointX, pointY)
				this._setGridXWithPixel(obj.x);
				this._setGridYWithPixel(obj.y);
				if (typeof this._pointX === "undefined") this._pointX = 50;
				if (typeof this._pointY === "undefined") this._pointY = 50;
				if(this._getOriginWidth() >= this._getOriginHeight()) {
					this._w = this._gridDisX * this._size / 100;
					this._h = this._gridDisX * this._size / 100 * (this._getOriginHeight() / this._getOriginWidth());
				} else {
					this._w = this._gridDisY * this._size / 100 * (this._getOriginWidth() / this._getOriginHeight());
					this._h = this._gridDisY * this._size / 100;
				}
			} catch (err) { B_Util.print(B_Define.MESSAGE["ERROR"] + err); }
		}

		// [V] protected

		// @DES :: parent {obj} - 부모 객체
		get _objParent() {
			if (this.CODMOS.WORLD && typeof this.CODMOS.WORLD[this._strParent] != 'undefined') {
				return this.CODMOS.WORLD[this._strParent];
			}
			if (this.CODMOS.TOOL && typeof this.CODMOS.TOOL[this._strParent] != 'undefined') {
				return this.CODMOS.TOOL[this._strParent];
			}
		}

		// [F] protected

		/**
		 * @DES :: 그리드 X, 픽셀과 함께 설정하기
		 * @OUT :: gridX {num}
		 */
		_setGridXWithPixel(gridX) {
			this._gridX = gridX;
			this._pixelX = this._getGridPixelX();
		}

		/**
		 * @DES :: 그리드 Y, 픽셀과 함께 설정하기
		 * @OUT :: gridY {num}
		 */
		_setGridYWithPixel(gridY) {
			this._gridY = gridY;
			this._pixelY = this._getGridPixelY();
		}

		/**
		 * @DES :: 그리드 X 이용해서 현재 PIXEL_X 리턴
		 * @S.E :: 그리드 (좌상) 시작점에서 처리됨
		 */
		_getGridPixelX() {
			return (this._gridX - 1) * this._gridDisX + this._gridDisX / 2
		}

		/**
		 * @DES :: 그리드 Y 이용해서 현재 PIXEL_Y 리턴
		 * @S.E :: 그리드 (좌상) 시작점에서 처리됨
		 */
		_getGridPixelY() {
			return (this._gridY - 1) * this._gridDisY + this._gridDisY / 2
		}

		/**
		 * @DES :: 앞의 그리드 좌표 배열로 얻기
		 * @IP1 :: rot {num}
		 * @IP2 :: dis {bum}
		 * @OUT :: frontGird {arr}
		 * @S.E :: rot [90, 180, 270, 360]만 가능
		 */
		_getFrontGrid(rot, dis) {
			if (typeof dis === "undefined") dis = 1;
			switch (rot) {
				case 90:
					return [this._gridX + 1 * dis, this._gridY];
					break;
				case 180:
					return [this._gridX, this._gridY + 1 * dis];
					break;
				case 270:
					return [this._gridX - 1 * dis, this._gridY];
					break;
				case 360:
					return [this._gridX, this._gridY - 1 * dis];
					break;
			}
		}

		/**
		 * @DES :: 앞에 픽셀 좌표 배열로 얻기
		 * @IP1 :: rot {num}
		 * @IP2 :: dis {num}
		 * @OUT :: frontPixel {arr}
		 * @S.E :: rot [90, 180, 270, 360]만 가능
		 */
		_getFrontPixel(rot, dis) {
			if (typeof dis === "undefined") dis = 1;
			switch (rot) {
				case 90:
					return [this._pixelX + this._gridDisX * dis, this._pixelY];
					break;
				case 180:
					return [this._pixelX, this._pixelY + this._gridDisY * dis];
					break;
				case 270:
					return [this._pixelX - this._gridDisX * dis, this._pixelY];
					break;
				case 360:
					return [this._pixelX, this._pixelY - this._gridDisY * dis];
					break;
			}
		}

		/**
		 * @DES :: 회전 방향으로 임시 이동시키는 함수
		 * @INP :: rot {num}
		 * @S.E :: rot [90, 180, 270, 360]만 가능
		 */
		_locateFrontGrid(rot) {
			switch (rot) {
				case 90:
					this._setGridXWithPixel(this._gridX + 1);
					break;
				case 180:
					this._setGridYWithPixel(this._gridY + 1);
					break;
				case 270:
					this._setGridXWithPixel(this._gridX - 1);
					break;
				case 360:
					this._setGridYWithPixel(this._gridY - 1);
					break;
			}
		}

		/**
		 * @DES :: 충돌체크 함수 (이동후 요청 - 즉, 발 아래를 확인합니다.)
		 * @INP :: obj[obj], arr[arr], cb[func]
		 * @OUT :: state[obj]
		 * @S.E ::
		 */
		_checkCrush(arrCrushObject, cb) {
			/**
			 * [순서]
			 *
			 * (그리드) > (길, 배경) > (객체) > (가상)
			 * */

			let ARR_CRUSH_PATH, ARR_CRUSH_OBJECT, ARR_CRUSH_VIRTUAL;

			// [#] 그리드내 검사
			if (!this._checkCrushOut()) {

				// [#] PATH :: path 배열이 있고, crush 배열로 지정
				ARR_CRUSH_PATH = this._checkCrushPath(arrCrushObject);

				// [#] OBJECT ::
				ARR_CRUSH_OBJECT = this._checkCrushObject(arrCrushObject);

				// [#] VIRTUAL ::
				ARR_CRUSH_VIRTUAL = this._checkCrushVirtual(arrCrushObject);

				cb(false/*grid-out*/, ARR_CRUSH_PATH, ARR_CRUSH_OBJECT, ARR_CRUSH_VIRTUAL)
			} else {
				cb(true/*grid-out*/);
			}
		}

		/**
		 * @DES :: 그리드 외부로 이동하는지 확인하는 함수
		 * @IP1 :: null
		 * @O.P :: null
		 * @S.E ::
		 */
		_checkCrushOut() {
			let CRUSH
			if (
				this._gridX < 1 || this._gridX > this._objParent._column
				||
				this._gridY < 1 || this._gridY > this._objParent._row
			) {
				CRUSH = true;
			} else {
				CRUSH = false;
			}

			// [T]
			// console.log(CRUSH);
			return CRUSH;
		}

		/**
		 * @DES :: 그리드내에서 길위에 있는지 확인하는 함수
		 * @IP1 :: arrCrushObject {arr}
		 * @O.P :: [crush, meta] {arr}
		 * @S.E ::
		 */
		_checkCrushPath(arrCrushObject) {
			let boolCrush = true, objMeta;

			if(arrCrushObject.indexOf(B_Define.PATH_TYPE) != -1) {
				boolCrush = false // 패스 상관 하는 게임 타입
			} else {
				boolCrush = true // 패스 상관 안하는 게임 타입
			}

			const LIST_PATH = this.CODMOS.WORLD.LIST.path;
			if (LIST_PATH) {
				for (let pKey in LIST_PATH) {
					if (
						LIST_PATH[pKey]._strParent == this._strParent
						&&
						LIST_PATH[pKey]._active
						&&
						LIST_PATH[pKey]._gridX == this._gridX
						&&
						LIST_PATH[pKey]._gridY == this._gridY
					) {
						// [#] 앞에 길이 있음
						objMeta = LIST_PATH[pKey]; // 패스 객체

						if (arrCrushObject.indexOf(B_Define.PATH_TYPE) != -1) { // 패스 상관 하는 게임 타입
							boolCrush = true; // 패스 충돌 여부
						}

						// [#] 밟힘 애니메이션 => 외부로
						// this.CODMOS.ANIMATE._tween.beStepped(pathList[pKey]);
					}

				}
			}

			// [T]
			// console.log(boolCrush, objMeta);
			return [boolCrush, objMeta];
		}

		/**
		 * @DES :: 그리드내에서 길위에 있는지 확인하는 함수
		 * @IP1 :: arrCrushObject {arr}
		 * @O.P :: [crush, meta] {arr}
		 * @S.E ::
		 */
		_checkCrushObject(arrCrushObject) {
			let boolCrush = false, objMeta;

			// [#] OBJ_TYPE => PATH & DECO 등등 제외하고 조회
			const UNDER_ITEM = this.checkUnderType(B_Define.OBJ_TYPE);
			if(UNDER_ITEM) {
				// [#] 발아래 객체가 확인됨
				objMeta = UNDER_ITEM;

				// [#] 발아래 객체와 충돌하는지 여부
				if (arrCrushObject.indexOf(UNDER_ITEM.type) != -1) boolCrush = true; // 충돌함
			}

			// [T]
			// console.log(boolCrush, objMeta);
			return [boolCrush, objMeta];
		}

		/**
		 * @DES :: 그리드내에서 길위에 있는지 확인하는 함수
		 * @IP1 :: virtualList {arr}
		 * @IP2 :: arrCrushObject {arr}
		 * @O.P :: [crush, meta] {arr}
		 * @S.E ::
		 */
		_checkCrushVirtual(arrCrushObject) {
			const LIST_VIRTUAL = this.CODMOS.WORLD.LIST.virtual;
			let boolCrush = false, objMeta;

			if (LIST_VIRTUAL) {
				for (let virKey in LIST_VIRTUAL) {
					if (LIST_VIRTUAL[virKey].enable) {
						LIST_VIRTUAL[virKey].arrGrid.forEach((v) => {
							if (v.gridX == this._gridX && v.gridY == this._gridY) {
								objMeta = LIST_VIRTUAL[virKey];

								// [#]
								if (arrCrushObject.indexOf(LIST_VIRTUAL[virKey].type) != 1) {
									boolCrush = true;
								}
							}
						})
					}
				}
			}

			// [T]
			// console.log(boolCrush, objMeta);
			return [boolCrush, objMeta];
		}

		// [F] public

		/**
		* [ Function :: checkUnderResource ]
		*
		* @DES :: 아래 위치한 리소스 key값 확인
		* @IP1 :: res {str}
		* @IP2 :: x {num}
		* @IP3 :: y {num}
		* @O.P :: rtn {boolean}
		*/
		checkUnderResource (res, x = this._gridX, y = this._gridY) {
			let arrSearchTypeItem = [];

			let searchTypeList = this.CODMOS.WORLD.LIST[B_Define.REAL_TYPE];
			for (let key in searchTypeList) {
				arrSearchTypeItem.push(searchTypeList[key]);
			}

			return arrSearchTypeItem.some(e => {
				if (
					x === e._gridX
					&&
					y === e._gridY
					&&
					res === e._res
				) {
					return true
				}
			});
		}

		/**
		 * [ Function :: checkFrontResource ]
		 *
		 * @DES :: 앞에 위치한 리소스 key값 확인
		 * @IP1 :: res {str}
		 * @O.P :: rtn {boolean}
		 */
		checkFrontResource (res, rotate) {
			const ROTATE = rotate ? rotate : this._rotate;

			/*임시 이동*/
			this._locateFrontGrid(ROTATE);

			const RESULT = this.checkUnderResource(res);

			/*원상 복귀*/
			this._locateFrontGrid(this._setSpecialRotate(ROTATE - 180));

			return RESULT;
		}

		/**
		 * @DES :: 아래 객체 타입 확인
		 * @IP1 :: type {str}
		 * @IP2 :: cb {func}
		 * @OUT :: rtn {bool}
		 * @S.E ::
		 */
		checkUnderType(type) {
			let rtn = false;
			let searchType = type ? type : B_Define.REAL_TYPE;
			let arrSearchTypeItem = [];

			// [#] 'BG'타입처리로직
			if (searchType == B_Define.BG_TYPE) searchType = B_Define.REAL_TYPE;

			// [#] 예외처리
			let searchTypeList = this.CODMOS.WORLD.LIST[searchType];
			for (let key in searchTypeList) {
				if (searchTypeList[key]._id == this._id) continue;
				if (!searchTypeList[key]._strParent) continue;
				if (searchTypeList[key]._type == B_Define.DECO_TYPE) continue;
				if (searchTypeList[key]._strParent != this._strParent) continue;
				if (!searchTypeList[key]._active) continue;
				arrSearchTypeItem.push(searchTypeList[key]);
			}

			for (let i = 0; i < arrSearchTypeItem.length; i++) {
				if (
					this._gridX == arrSearchTypeItem[i]._gridX
					&&
					this._gridY == arrSearchTypeItem[i]._gridY
				) {
					rtn = arrSearchTypeItem[i];
				}
			}

			// [#] 'BG'타입처리로직
			if (searchType == B_Define.BG_TYPE) rtn = rtn ? false : true;

			// /*[T]*/ console.log(rtn);
			return rtn;
		}

		/**
		 * @DES :: 앞선 타입 확인
		 * @INP :: type {str}
		 * @OUT :: rotate {num}
		 * @S.E :: cb {func}
		 */
		checkFrontType(type, rotate) {
			const TYPE = type ? type : B_Define.REAL_TYPE;
			const ROTATE = rotate ? rotate : this._rotate;

			/*임시 이동*/
			this._locateFrontGrid(ROTATE);

			/*체크 체크*/
			const RESULT = this.checkUnderType(TYPE);

			/*원상 복귀*/
			this._locateFrontGrid(this._setSpecialRotate(ROTATE - 180));

			return RESULT;
		}

        /**
         * @DES :: 아래 속성 타입 확인
         * @IP1 :: key {str}
         * @IP2 :: value {str}
         * @IP3 :: type {str}
         * @OUT :: rtn {bool}
         * @S.E ::
         */
        checkUnderAttr(key, value, type) {
            let rtn = false;
            let searchType = type ? type : "path";
            let arrSearchTypeItem = [];

            let searchTypeList = this.CODMOS.WORLD.LIST[searchType];
            for (let key in searchTypeList) {
                arrSearchTypeItem.push(searchTypeList[key]);
            }

            arrSearchTypeItem.some(e => {
            	if (
            		e[key] === value
					&&
                    this._gridX === e._gridX
                    &&
                    this._gridY === e._gridY
				) {
                    rtn = true
				}
			});

            // /*[T]*/ console.log(rtn);
            return rtn;
        }

        /**
         * @DES :: 앞선 속성 확인
         * @IP1 :: key {str}
         * @IP2 :: value {str}
         * @IP3 :: type {str}
         * @IP4 :: rotate {num}
         * @OUT :: result {bool}
         * @S.E ::
         */
        checkFrontAttr(key, value, type, rotate) {
            const ROTATE = rotate ? rotate : this._rotate;

            /*임시 이동*/
            this._locateFrontGrid(ROTATE);

            /*체크 체크*/
            const RESULT = this.checkUnderAttr(key, value, type);

            /*원상 복귀*/
            this._locateFrontGrid(this._setSpecialRotate(ROTATE - 180));

            return RESULT;
        }

        /**
         * @DES :: 앞선 발판 색상 확인
         * @INP :: color {str}
         * @OUT :: result {bool}
         * @S.E ::
         */
        checkFrontPathColor(color) {
            const RESULT = this.checkFrontAttr("color", color, "path");
            return RESULT;
		}

		checkBackType(type) {
			const TYPE = type ? type : B_Define.REAL_TYPE;
			const ROTATE = this._rotate;

			/*임시 이동*/
			this._locateFrontGrid(this._setSpecialRotate(ROTATE - 180));

			/*체크 체크*/
			const RESULT = this.checkUnderType(TYPE);

			/*원상 복귀*/
			this._locateFrontGrid(ROTATE);

			return RESULT;
		}

		checkLeftType(type) {
			const TYPE = type ? type : B_Define.REAL_TYPE;
			const ROTATE = this._rotate;

			/*임시 이동*/
			this._locateFrontGrid(this._setSpecialRotate(ROTATE - 90));

			/*체크 체크*/
			const RESULT = this.checkUnderType(TYPE);

			/*원상 복귀*/
			this._locateFrontGrid(this._setSpecialRotate(ROTATE + 90));

			return RESULT;
		}

		checkRightType(type) {
			const TYPE = type ? type : B_Define.REAL_TYPE;
			const ROTATE = this._rotate;

			/*임시 이동*/
			this._locateFrontGrid(this._setSpecialRotate(ROTATE + 90));

			/*체크 체크*/
			const RESULT = this.checkUnderType(TYPE);

			/*원상 복귀*/
			this._locateFrontGrid(this._setSpecialRotate(ROTATE - 90));

			return RESULT;
		}

		/**
		 * @DES :: 발아래 리소스 확인
		 * @IP1 :: res {str}
		 * @OUT ::
		 * @S.E ::
		 */
		checkUnderRes(res) {
			let rtn = false;
			const LIST = this.CODMOS.WORLD.LIST;
			const ARR = [];

			// 배열로 바꾸는 이유? 뒤에서 부터 조회하기 위함
			// 'real' 타입에 국한해서 모두 조회합니다.
			for (let key in LIST.real) { ARR.push(LIST.all[key]); }

			for (let i = (ARR.length - 1); i >= 0; i--) {
				if (ARR[i].type != B_Define.DECO_TYPE) {
					if (!rtn && this._id != ARR[i]._id) {
						if (
							this._strParent == ARR[i]._strParent
							&&
							this._gridX == ARR[i]._gridX
							&&
							this._gridY == ARR[i]._gridY
						) {
							if (ARR[i]._res == res) {
								rtn = ARR[i];
							}
						}
					}
				}
			}
			return rtn;
		}

		/**
		 * @DES :: 앞에 리소스 확인
		 * @IP1 :: res {str}
		 * @IP2 :: rotate {num}
		 * @IP3 :: cb {func}
		 * @OUT ::
		 * @S.E ::
		 */
		checkFrontRes(res, rotate) {
			const RES = res ? res : "";
			const ROTATE = rotate ? rotate : this._rotate;

			/*임시 이동*/
			this._locateFrontGrid(ROTATE);

			/*체크 체크*/
			const ITEM = this.checkUnderRes(RES);

			/*원상 복귀*/
			this._locateFrontGrid(this._setSpecialRotate(ROTATE - 180));

			return ITEM;
		}


	}

	B_Util.manageGetAndSet(B_GridChild, $);
	return B_GridChild;
});

export default B_GridChild;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/grid/B_GridChild.js